// extracted by css-extract-rspack-plugin
export default {"root":"root-zFMqFS","active":"active-Jbh03W","icon":"icon-kDCyAE","list":"list-euj5Gb"};